import { Model } from "@/models/base/model";
import { _$t } from "@/utils/i18n";

export class HospitalVisit extends Model {
  private baseUrl = "/cms/api/my-record/hospital-visit"; // ベースURL
  // コンストラクタ
  constructor(params: any = {}) {
    super(params);
    this.url = this.baseUrl;
    this.validation = this.getValidationSchema();
    this.labels = this.getValidationLabels();
  }

  // 保存処理
  async save(): Promise<any> {
    this.url = `${this.baseUrl}/save`;
    return await super.save({}, "POST");
  }

  // 病院受診データの詳細を取得
  async getData(hodpitalVisitId: number | null): Promise<any> {
    this.url = `${this.baseUrl}/get-detail`;
    if (hodpitalVisitId) {
      const searchParams = new URLSearchParams();
      searchParams.append("id", hodpitalVisitId.toString());
      this.url = `${this.url}?${searchParams.toString()}`;
    }
    return await super.fetch();
  }

  // 削除処理
  async delete(hodpitalVisitId: number | null): Promise<any> {
    this.url = `${this.baseUrl}/delete`;
    return await super.save({ hospitalVisitId: hodpitalVisitId }, "DELETE");
  }

  // 病院受診一覧画面情報取得
  async getPageData(): Promise<any> {
    this.url = this.baseUrl;
    return await super.fetch();
  }

  // 病院訪問件数取得
  async getHospitalVisitCount(searchConditions: {
    disease?: string;
    year?: number;
  }): Promise<any> {
    this.url = `${this.baseUrl}/count`;
    const searchParams = new URLSearchParams();

    if (
      searchConditions?.disease !== undefined &&
      searchConditions?.disease !== null
    ) {
      searchParams.append("disease", searchConditions.disease);
    }
    if (searchConditions?.year) {
      searchParams.append("year", searchConditions.year.toString());
    }

    if (searchParams.toString()) {
      this.url = `${this.url}?${searchParams.toString()}`;
    }

    return await super.fetch();
  }

  // 病院受診一覧取得
  async getPaginatedData(
    page: number,
    cond: {
      disease?: string;
      year?: number;
    }
  ): Promise<any> {
    this.url = `${this.baseUrl}/paginated`;
    const searchParams = new URLSearchParams();

    if (page) {
      searchParams.append("page", page.toString());
    }
    if (cond?.disease !== undefined && cond?.disease !== null) {
      searchParams.append("disease", cond.disease);
    }
    if (cond?.year) {
      searchParams.append("year", cond.year.toString());
    }

    if (searchParams.toString()) {
      this.url = `${this.url}?${searchParams.toString()}`;
    }

    return await super.fetch();
  }

  // バリデーションルール
  getValidationSchema() {
    return {
      // 診療科名
      hospitalDepartmentName: {
        required: false,
        type: "string",
        maxLength: 100,
      },
    };
  }
  // バリデーションラベル
  getValidationLabels() {
    return {
      hospitalDepartmentName: _$t("hospital_visit_label_department"),
    };
  }
}
